<template>
    <div class="action-menu">

        <button type="button" @click="isOpen = !isOpen">
            <svg class="dotdotdot"><use xlink:href="#dotdotdot"></use></svg>
        </button>

        <div class="backdrop" v-if="isOpen" @click="isOpen = false"></div>

        <Transition enter-active-class="animate__animated animate__fadeIn"
                    leave-active-class="animate__animated animate__fadeOut">

            <div class="menu" v-show="isOpen">
                <ul>
                    <li style="position: relative">
                        <a href="#" @click="changeDays()">
                            <svg class="change_cal"><use xlink:href="#change_cal"></use></svg>
                            Change Day(s)
                        </a>
                    </li>
                    <li v-if="schedule.hasOwnProperty('id')">
                        <a href="#" @click="unschedule()">
                            <svg class="change_cal"><use xlink:href="#change_cal"></use></svg>
                            Unschedule
                        </a>
                    </li>
                    <li>
                        <a href="#" @click="removeFromList()">
                            <svg class="remove_from_list"><use xlink:href="#remove_from_list"></use></svg>
                            Remove From List
                        </a>
                    </li>
                </ul>
            </div>

        </Transition>

    </div>
</template>
<script>

export default {


    props:['index', 'list', 'schedule', 'currentTab'],

    data(){
        return {
            spot: this.schedule.spot,
            isOpen: false,
        }
    },

    methods:{
        changeDays(){
            eventBus.$emit('open-add-to-schedule-modal', {
                spot: this.spot,
                tab: this.currentTab
            })
            this.isOpen = false
        },

        unschedule(){
            axios.delete(`/lists/${this.list.id}/schedules/${this.schedule.id}`)
                .then(response => {
                    eventBus.$emit('fetch-schedule')
                })
            this.isOpen = false
        },

        removeFromList() {
            axios.delete(`/lists/${this.list.id}/spot/${this.schedule.spot.slug}`).then(response => {
                eventBus.$emit('fetch-schedules')
                eventBus.$emit('deleted-spot-from-list', response.data.list);
            })
            this.isOpen = false
        }
    },

}
</script>
